import React, { Component } from "react";

export class Numeric extends Component {
  constructor(props) {
    super(props);

    this.state = { value: parseInt(props.value) || 0 };
  }

  render() {
    return (
      <div className="numeric">
        <button
          className="numeric-button left"
          onClick={() =>
            this.setValue({
              value: Math.max(this.state.value - 1, this.props.minValue || 0),
            })
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 48 48"
          >
            <path fill="#2B2A3A" fill-rule="nonzero" d="M12 26v-3h25v3z" />
          </svg>
        </button>
        <input
          className="numeric-value"
          type="text"
          value={+this.state.value}
          onBlur={(e) =>
            this.setValue({
              value: Math.max(
                Math.min(e.target.value, this.props.maxValue || Infinity),
                this.props.maxValue || 0
              ),
            })
          }
        />
        <button
          className="numeric-button right"
          onClick={() =>
            this.setValue({
              value: Math.min(
                this.state.value + 1,
                this.props.maxValue || Infinity
              ),
            })
          }
        >
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 48 48"
          >
            <path
              fill="#2B2A3A"
              fill-rule="nonzero"
              d="M26 22h11v3H26v11h-3V25H12v-3h11V11h3v11z"
            />
          </svg>
        </button>
      </div>
    );
  }

  setValue(value) {
    this.setState(value);
    this.props.onValueChanged(value);
  }
}
